import React, { memo, useCallback } from "react";
import { NodeResizer, Position, useReactFlow } from '@xyflow/react';
import OneToOneHandle from "../handles/OneToOneHandle";
import NodeModal from "../modal/NodeModal";
import { ButtonMore } from "../../buttonMore/buttonMore";
import { ConfirmModal } from "../../confirm/ConfirmModal";

const ConditionNode = ({id, data, selected}) => {
  const { updateNodeData, setNodes } = useReactFlow();

  const handleDelete = useCallback(() => {
    setNodes((nodes) => nodes.filter((node) => node.id !== id));
  }, [id, setNodes]);

  const handleChange = useCallback((evt) => {
    updateNodeData(id, {value: evt.target.value});
  }, [id, updateNodeData]);

  const handleChangeData = useCallback((item) => {
    updateNodeData(item.id, item.data);
  }, [updateNodeData]);

  return (
    <>
      <NodeResizer
        color="#ff0071"
        isVisible={selected}
        minWidth={220}
        minHeight={100}
      />
      <div className="react-flow_card">
        <div className="node">
          <div className="node-card">
            <div className="node-content">
              <OneToOneHandle type="target" position={Position.Top} id="input" />
              <OneToOneHandle 
                type="source" 
                position={Position.Bottom} 
                id="out_true"
                condition={1}
                width={20}
                height={20}
                style={{ background: "green", left: '75%' }}
                isValidConnection={({ targetHandle }) => targetHandle.includes("action") || targetHandle.includes("input")} />
              <OneToOneHandle 
                type="source" 
                position={Position.Bottom} 
                id="out_false"
                condition={1}
                style={{ background: "red", left: '25%' }}
                isValidConnection={({ targetHandle }) => targetHandle.includes("action") || targetHandle.includes("input")} />
              <div className="node-header-right">
                <ButtonMore>
                  <ul className="dropdown">
                    <NodeModal trigger={<li className="dropdown__item icon-edit"><span>{data?.disabled ? 'Просмотр' : 'Редактировать'}</span></li>} 
                      triggerWrap={false}
                      itemID={id} 
                      type={"ConditionNode"} 
                      data={data} 
                      handleOk={handleChangeData} />
                    {!data?.disabled && <ConfirmModal trigger={<li className="dropdown__item icon-delete"><span>Удалить</span></li>} triggerWrap={false} title={"Удалить блок?"} handleOk={() => handleDelete()}/>}
                  </ul>
                </ButtonMore>
              </div>
              <div className="node-header">
              Блок с условием
              </div>
              <div className="node-description">
                <input
                  type="text"
                  className="input"
                  name="value"
                  value={data?.value || ''}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(ConditionNode);
